function setup(width, height, cookie, displayAgainTime, timeout) {
    var elmt = document.getElementById('popup');
    cookie = "popup" + cookie;
    elmt.style.width = width + 'px';
    elmt.style.height = height + 'px';

    document.addEventListener('DOMContentLoaded', (event) => {
        const popup = document.getElementById('popup');
        const closePopupBtn = document.getElementById('closePopupBtn');

        // Show the popup with a bounce effect on page load
        if (Cookies.get(cookie) == null) {
            timeout = timeout * 1000;
            setTimeout(function () {
                popup.classList.add('popup-active');
            }, timeout);
        }
        
        closePopupBtn.addEventListener('click', () => {
            popup.classList.remove('popup-active');
            //document.cookie = "popup" + cookie + ";" + displayAgainTime + ";path=/";
            if (Cookies.get(cookie) == null) {
                Cookies.set(cookie, 'yes', { expires: displayAgainTime, path: '/' });
            }
        });
    });
}
